import React from 'react';
import Icon from '../components/Icon';

export default function ConnectScreen({ connectedApps, uberData, taxi99Data, onConnect, score, scoreColor, discount, totalRides, avgRating, maxYears }) {
  const apps = [
    { key:'uber',   name:'Uber', icon:'car',  data:uberData,   bg:'rgba(0,0,0,0.4)' },
    { key:'taxi99', name:'99',   icon:'zap',  data:taxi99Data, bg:'rgba(255,215,0,0.1)' },
  ];

  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:900, margin:'0 auto' }}>
      <div style={{ marginBottom:32 }}>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:700, color:'#fff', marginBottom:8 }}>
          Conectar Apps de Mobilidade
        </h2>
        <p style={{ color:'var(--fg3)', fontSize:16, lineHeight:1.6 }}>
          Vincule suas contas para calcular seu score automaticamente e liberar descontos exclusivos.
        </p>
      </div>

      <div style={{ display:'grid', gap:20, marginBottom:32 }}>
        {apps.map(app => (
          <div key={app.key} style={{
            background:'var(--surface)', border:'1px solid var(--border)',
            borderRadius:'var(--radius-lg)', padding:28,
          }}>
            <div style={{ display:'flex', alignItems:'center', gap:20, marginBottom: connectedApps[app.key] ? 24 : 0 }}>
              <div style={{
                width:60, height:60, borderRadius:14, background:app.bg,
                display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
                border:'1px solid rgba(255,255,255,0.15)',
              }}>
                <Icon name={app.icon} size={32} strokeWidth={2.5} style={{ color: app.key === 'uber' ? '#fff' : '#FFD700' }} />
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:18, color:'#fff', marginBottom:4 }}>{app.name}</div>
                <div style={{ fontSize:14, color: connectedApps[app.key] ? 'var(--green)' : 'var(--fg4)', display:'flex', alignItems:'center', gap:6 }}>
                  {connectedApps[app.key] && <Icon name="check-circle" size={16} style={{ color:'var(--green)' }} />}
                  {connectedApps[app.key] ? 'Conectado' : 'Não conectado'}
                </div>
              </div>
              {!connectedApps[app.key]
                ? <button className="btn btn-primary" style={{ padding:'12px 24px', fontSize:14 }} onClick={() => onConnect(app.key)}>
                    <Icon name="link-2" size={16} />
                    Conectar
                  </button>
                : <span className="badge badge-green" style={{ padding:'8px 16px', fontSize:13 }}>
                    <Icon name="check" size={14} />
                    Ativo
                  </span>
              }
            </div>

            {connectedApps[app.key] && (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:14, paddingTop:20, borderTop:'1px solid var(--border)' }}>
                {[
                  [<Icon name="car" size={20} style={{ color:'var(--orange)' }} />, app.data.rides.toLocaleString('pt-BR'), 'Corridas'],
                  [<Icon name="star" size={20} style={{ color:'var(--orange)', fill:'var(--orange)' }} />, app.data.rating.toFixed(2), 'Nota'],
                  [<Icon name="calendar" size={20} style={{ color:'var(--orange)' }} />, `${app.data.years}a`, 'Ativo há'],
                ].map(([icon, val, lbl]) => (
                  <div key={lbl} style={{ textAlign:'center', background:'var(--surface2)', borderRadius:12, padding:16 }}>
                    <div style={{ marginBottom:8 }}>{icon}</div>
                    <div style={{ fontWeight:700, fontSize:18, color:'#fff', marginBottom:4 }}>{val}</div>
                    <div style={{ fontSize:12, color:'var(--fg4)' }}>{lbl}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {(connectedApps.uber || connectedApps.taxi99) && (
        <div style={{
          background:'linear-gradient(135deg, rgba(255,92,0,0.12), rgba(255,92,0,0.04))',
          border:'1px solid rgba(255,92,0,0.25)',
          borderRadius:'var(--radius-lg)', padding:28,
        }}>
          <h3 style={{ fontWeight:700, fontSize:18, color:'#fff', marginBottom:20, display:'flex', alignItems:'center', gap:10 }}>
            <Icon name="bar-chart-2" size={20} style={{ color:'var(--orange)' }} />
            Breakdown do seu score
          </h3>
          {[
            ['Corridas (40%)',      Math.min(totalRides / 5000, 1) * 100,                              'var(--orange)', 'car'],
            ['Avaliação (35%)',     avgRating > 0 ? Math.min(((avgRating - 3.5) / 1.5) * 100, 100) : 0, '#F59E0B',       'star'],
            ['Tempo ativo (25%)',   Math.min((maxYears / 5) * 100, 100),                               'var(--green)',   'calendar'],
          ].map(([label, pct, color, icon]) => (
            <div key={label} style={{ marginBottom:18 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, color:'var(--fg3)', marginBottom:8, alignItems:'center' }}>
                <span style={{ display:'flex', alignItems:'center', gap:8 }}>
                  <Icon name={icon} size={16} style={{ color }} />
                  {label}
                </span>
                <span style={{ color, fontWeight:600, fontFamily:'var(--font-display)' }}>{Math.round(pct)}%</span>
              </div>
              <div className="progress-track" style={{ height:8 }}>
                <div className="progress-fill" style={{ width:`${pct}%`, background:color }} />
              </div>
            </div>
          ))}
          <div style={{
            marginTop:24, display:'flex', justifyContent:'space-between', alignItems:'center',
            paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.1)',
          }}>
            <div>
              <div style={{ fontSize:13, color:'var(--fg4)', marginBottom:4 }}>Seu desconto atual</div>
              <div style={{ fontFamily:'var(--font-display)', fontSize:32, fontWeight:800, color:'var(--orange)' }}>
                {discount}% OFF
              </div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize:13, color:'var(--fg4)', marginBottom:4 }}>Score total</div>
              <div style={{ fontFamily:'var(--font-display)', fontSize:32, fontWeight:800, color:scoreColor }}>
                {score}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
